
import React from 'react';
import { useSelector } from 'react-redux';

import {
    getCalculationOperations
} from '../../reducers/project';

import getModificationById from './getModificationById';
import getOperationById from './getOperationById';
import getOperationsForModification from './getOperationsForModification';
import getUsekQuantity from './getUsekQuantity';
import Modification from './Modification.state';
import UsekView from './Usek.view';

const Usek = ({
    col,
    attributes,
    usek
}) => {

    const calculationOperations = useSelector(state => getCalculationOperations(state.project));

    const calcPrice = (quantity, operations) => {
        return operations.reduce((previous, current) => {
            let calcOp = calculationOperations[`${usek.properties.id_usek}_${current.id}`];
            if (calcOp) {
                let mj = getOperationById(current.id).mj;
                return previous + (calcOp.pricePerUnit * quantity[mj]);
            } else {
                return previous;
            }
        }, 0);
    }

    const handleRenderModification = (modification, operations) => {
        return (
            <Modification
                usek={usek}
                usekAttributes={attributes}
                modification={modification}
                operations={operations}
                quantity={quantity}
            />
        );
    }

    const mob = getModificationById(attributes.typ_uprav_stavba);
    const mov = getModificationById(attributes.typ_uprav_vegetace);
    const operationsb = getOperationsForModification(mob);
    const operationsv = getOperationsForModification(mov);
    const quantity = getUsekQuantity(attributes);

    const price = calcPrice(
        quantity,
        [
            ...operationsb,
            ...operationsv
        ]
    );

    return (
        <UsekView
            quantity={quantity}
            col={col}
            attributes={attributes}
            modificationBuilding={mob}
            modificationVegetation={mov}
            onRenderModification={handleRenderModification}
            operationsBuilding={operationsb}
            operationsVegetation={operationsv}
            price={price}
            usek={usek}
        />
    );
}

export default Usek;
